import { SplashScreen } from "@westpierstudio/luma/game";
import { OryxGame } from "@westpierstudio/core-module-oryx/game";
import { DragonsVsPandasGameController } from "game/DragonsVsPandasGameController";
import { KSGLoadingScreen } from "@westpierstudio/core-module-oryx/game/KSGLoadingScreen";
import { DragonsVsPandasGameModel } from "./DragonsVsPandasGameModel";
import { DragonsVsPandasGameView } from "./DragonsVsPandasGameView";
import { DragonsVsPandasGameClient } from "game/DragonsVsPandasGameClient";
import { GameServices } from "./GameServices";


export class DragonsVsPandasGame extends OryxGame {

    constructor(
        protected override services: GameServices,
        protected override gameModel: DragonsVsPandasGameModel,
        protected override gameView: DragonsVsPandasGameView,
        protected override gameController: DragonsVsPandasGameController,
        protected override loadingScreen: KSGLoadingScreen,
        protected override splashScreen: SplashScreen | undefined,
        protected override gameClient: DragonsVsPandasGameClient
    ) {
        super(
            services,
            gameModel,
            gameView,
            gameController,
            loadingScreen,
            splashScreen,
            gameClient,
            {realTime3D: true}
        );
    }

    protected override startApplication(): void {
        super.startApplication();
        this.services.application.renderer.backgroundColor = 0x000000;
    }

    override onSupportingResourcesLoaded() {

        const {layout, resources} = this.services;

        const padding = resources.getSetting(`bucketPadding`);

        if (padding) {

            const applyPadding = () => {
                layout.setPadding(padding[layout.orientation]);
            };

            layout.onReorient.add(applyPadding);
            applyPadding();
        }
    }
}